<template>
  <div class="fg-spinner" role="status" :aria-label="label">
    <svg class="fg-spinner__svg" viewBox="0 0 50 50">
      <circle cx="25" cy="25" r="20" fill="none" stroke-width="4" />
    </svg>
    <span v-if="label">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ label?: string }>()
</script>
